var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.66667C10 0.746192 10.7462 0 11.6667 0H15C15.9205 0 16.6667 0.746192 16.6667 1.66667V13.3333C16.6667 14.2538 15.9205 15 15 15H1.66667C0.746192 15 0 14.2538 0 13.3333V8.33333C0 7.41286 0.746192 6.66667 1.66667 6.66667H5V5C5 4.07953 5.74619 3.33333 6.66667 3.33333H10V1.66667ZM11.6667 13.3333H15V1.66667H11.6667V13.3333ZM10 5H6.66667V13.3333H10V5ZM5 8.33333H1.66667V13.3333H5V8.33333Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyChartIcon);
export default __webpack_public_path__ + "static/media/GreyChartIcon.5dbf09dba136fa84f028b8832574a71b.svg";
export { ForwardRef as ReactComponent };